import * as React from "react";
import { SVGProps, memo } from "react";

const SvgArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg width={32} height={32} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.116 16.884a1.25 1.25 0 0 1 0-1.768l9-9a1.25 1.25 0 0 1 1.768 1.768L12.768 16l8.116 8.116a1.25 1.25 0 0 1-1.768 1.768l-9-9Z"
      fill="#2BA168"
    />
  </svg>
);

const Memo = memo(SvgArrowLeft);

export default Memo;
